import React from "react";
import DemographicsChart from "../ProfileInfo/DemoComp";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import Media from "../Media";

const Instagram = ({ profileData, isBrand }) => {
  //console.log("Instagram profileData", profileData);
  return (
    <div style={{ fontFamily: "Gilroy-Medium" }}>
      <div className="  w-full md:w-full ">
        <h1>Instagram Analytics</h1>

        {profileData?.instaId &&
          (
            <div className="flex gap-2">
            <span className="py-1 px-3 rounded-full bg-[#ff006b] text-white">
              @{profileData.instaUsername}
            </span> 
              <span className="py-1 px-3 rounded-full bg-[#ff006b] text-white cursor-pointer">
                Refresh
              </span>
              </div>
          ) }

        {profileData?.instaId ? (
          <>
            <div className="flex md:flex-row xs:flex-col gap-4 justify-between w-full my-3">
              <StatCard
                title="Total Followers"
                value={profileData?.followers}
                change="123"
                isPositive={true}
              />
              <StatCard
                title="Engagement Rate"
                value={profileData?.ER}
                change="1.5%"
                isPositive={false}
              />
              <StatCard
                title="Total Content"
                value={profileData?.totalPost}
                change="20k"
                isPositive={true}
              />
              <StatCard
                title="Profile Visits"
                value={profileData?.profileVisit || "-"}
                change="2k"
                isPositive={true}
              />
            </div>
          </>
        ) : (
          !isBrand && (
            <button className="px-4 py-2 bg-pink-600 text-white rounded-lg  mt-2">
              Connect Instagram
            </button>
          )
        )}
      </div>

      <div>
        {profileData.instaId && <DemographicsChart profileData={profileData} />}
      </div>

      <div>
           <Media media={profileData?.media} />
      </div>
    </div>
  );
};

const StatCard = ({ title, value, change, isPositive }) => (
  <div className="bg-white p-4 rounded-2xl border-2 border-gray-300 w-full text-gray-800">
    <p className="text-sm mb-1 text-gray-500">{title}</p>
    <p className="text-2xl font-bold mb-0">{value}</p>
  </div>
);

export default Instagram;
